import '../../styles/RightQuadrant.css'
import Selector from '../../Selector'
import InfoStatus from '../../InfoStatus'
import Action from '../../Action'
import {fetchData} from '../../../hooks/fetchData'
import { useFetch } from '../../../hooks/useFetch'
import { Suspense, useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import {permisos_codigo_id,servidores_id} from '../../generales/GroupsId'
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import InfoContadores from '../../modals-monitoreo/InfoContadores'
import Modal from "react-modal";
import StatBarNew from './StatBarNew';
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "70%",
    padding: "20px",
  },
};
const RightQuadrant =(props)=>{
    const dispId_default=(props.ubicacion.groupid==390)?0:-1

    function getColorById(id) {
        const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
        return agency ? agency.color : null;
      }
    // console.log(props.userPermissions)
    // console.log(props)
    const dataLocations=useFetch('zabbix/groups/municipios','',props.token,'GET',props.server)
    // const [props.dataTec,props.setDataTec]=useState({data:[],loading:true,error:null})
    const [dataAuxTecFiltrado,setdataAuxTecFiltrado]=useState({})
    const [dataDisp,setDataDisp]=useState({data:[],loading:true,error:null})
    const [openExepList,setOpenExcepList]=useState(false)
    const [openExepListCity,setOpenExcepListCity]=useState(false)
    //    //console.log(props.dataTec.data)
    //    //console.log(props.downs_list)
    const metrica=dataDisp.data.find(obj => obj.template_id === props.ubiActual.templateId)


    if( typeof(metrica) !=="undefined"){
     props.setMetricaSelected(metrica.nickname) 
    }
    //    
    let s4= undefined
    let s3= undefined
    let s2= undefined
    let s1=undefined
    const token_item=localStorage.getItem('access_token')
    // console.log(dataAuxTecFiltrado)
    // console.log(props.downs_list.data)
    if(props.dataHosts.data.length!=0){
     s4= props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 4)
     s3= props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 3)
     s2= props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 2)
     s1= props.dataHosts.data.problems_by_severity.find(obj => obj.severity === 1)
    }

    function buscar(){
        props.setDemoRelaciones([])
        if(props.origen=='eventos'){
            props.setAutoRefresh(false)
        }
       
            props.setRfid([])
            props.setLpr([])
       props.setCapas({})
        let aux_municipio=dataLocations.data.data.find(obj => obj.groupid === props.ubicacion.groupid)
        if(aux_municipio===undefined){
            aux_municipio='Todos'
        }
        props.setUbiActual({municipio:aux_municipio.name,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId:props.ubicacion.templateId})
        props.search_problems()
        // props.search_exceptions()
        props.search_downs()
     
        if(props.ubicacion.dispId!==-1){
            props.search_devices()
        }else{
            // props.search_exceptions()
            props.setDevices({data:[],loading:false,error:null})
        }
        if(props.ubicacion.dispId===1){
            props.search_lpr()
        }
        if(props.ubicacion.dispId===9){
            props.search_rfid()
        } 
        if(props.ubicacion.dispId===12){
            //console.log('switches')
            props.search_switches()
        }else{
            // console.log('elimina rfi')
            props.setRfid([])
            props.setLpr([])
        }
        
    }

    useEffect(()=>{

        search_tecnologias()
    },[props.ubicacion.groupid])
    function filtrarPorPermiso(objeto, servidores_id, userPermissions) {
        return objeto.filter(item => {
          const dispId = item.dispId;
          return (servidores_id[dispId] === undefined || 
                  (servidores_id[dispId] !== undefined && 
                   userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['servidores_'+dispId])));
        });
      }
    useEffect(()=>{
if(dataLocations.loading==false){
      buscar()
  }
    },[dataLocations.loading])//props.ubicacion.dispId
    //   useEffect(()=>{

    //     buscar()

    //   },[])
    useEffect(()=>{
        let dispId=-1
        if(props.dataTec.data.length!==0){
        if(props.userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['ODD'])){
                props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:-1,templateId:props.ubicacion.templateId})
        }else{
            
//              dispId =
//                 props.dataTec.data.find(
//                     d => d.name === props.userPermissions.find(p => p.description === 'lista tecnologías')?.module_name
//                 )?.dispId;
//   console.log(dispId);
  const allowedModules = new Set(
  props.userPermissions.map(p => p.module_name)
);

// 2. Recorre dataTec en orden y toma el primero que esté en los permisos
 dispId = props.dataTec.data.find(d => allowedModules.has(d.name))?.dispId;

         props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:dispId,templateId:props.ubicacion.templateId})
    
           
        }
  
        let aux_deft=dispId//props.dataTec.data.find(obj => obj.dispId === dispId_default)
        if(aux_deft===undefined){
            //console.log("undefined",props.dataTec.data[0].dispId)

            props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:dispId,templateId:props.ubicacion.templateId})
        }else{
            props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:dispId,templateId:props.ubicacion.templateId})
        }
        // setdataAuxTecFiltrado(filtrarPorPermiso(props.dataTec.data, servidores_id,props.userPermissions))
        setdataAuxTecFiltrado([...[{ dispId: -1, name: "ODD", id: -1 }],...filtrarPorPermiso(props.dataTec.data, servidores_id,props.userPermissions)])
    }

    },[props.dataTec])

    function search_tecnologias(){
        
        props.setDataTec({data:props.dataTec.data,loading:true,error:props.dataTec.error})
          const fetchData = async () => {
            try {
           const response = await fetch(props.server.url+'/api/v1/zabbix/groups/devices/'+props.ubicacion.groupid, {                 
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token_item}`,
                                  },
                                });
                                // //console.log(response)
              if (response.ok) {
                  const response_data = await response.json();
                  props.setDataTec({data:response_data.data,loading:false,error:props.dataTec.error})
              } else {
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
              // Manejo de errores
              props.setDataTec({data:props.dataTec.data,loading:props.dataTec.loading,error:error})
              //console.error(error);
            }
          };
          fetchData();
      }
    useEffect(()=>{
      
      // search_metricas()
  },[props.ubicacion.dispId])
    useEffect(()=>{
        if(dataDisp.data.length!==0){
           
            let aux_deft=dataDisp.data.find(obj => obj.id === 0)
            if(aux_deft===undefined){
                props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId:0})
            }else{
                props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId:0})
            }
        
    }
    },[dataDisp])

    function search_metricas(){
        
        setDataDisp({data:props.dataTec.data,loading:true,error:props.dataTec.error})
          const fetchData = async () => {
            try {
           const response = await fetch(props.server.url+'/api/v1/zabbix/groups/subtypes/'+props.ubicacion.dispId, {                 
                                  headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token_item}`,
                                  },
                                });
                                // //console.log(response)
              if (response.ok) {
                const response_data = await response.json();
                setDataDisp({data:response_data.data,loading:false,error:props.dataTec.error})
              
                
              } else {
                throw new Error('Error en la solicitud');
              }
            } catch (error) {
              // Manejo de errores
              setDataDisp({data:props.dataTec.data,loading:props.dataTec.loading,error:error})
              //console.error(error);
            }
          };
          fetchData();
      }
    const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
    const [tipo,setTipo]=useState('')
    const handleClickInfo=(tipo)=>{
     setTipo(tipo)
   setCreateCisModalOpen(true);
       }
    function closCreateCisModal() {

setCreateCisModalOpen(false);
}
    const [filtrosContainer, setFiltrosContainer] = useState(null);
    useEffect(() => {
        setFiltrosContainer(document.getElementById('filtros-container'));
    }, []);

    // New counter logic
    const statCounts = {
        up: (props.ubiActual.dispId === -1 || props.loaderMap) ? null : (props.dataHosts.data?.global_host_availables?.[0]?.UP || 0),
        unk: (props.ubiActual.dispId === -1 || props.loaderMap) ? null : (props.dataHosts.data?.global_host_availables?.[0]?.Unkonwn || 0),
        down: (props.downs_list.loading || props.loaderMap) ? null : (props.downs_list.data?.filter_count?.downs_totales || 0),
        odd: (props.downs_list.loading || props.loaderMap) ? null : (props.downs_list.data?.filter_count?.downs_origen || 0),
        exc: (props.downs_list.loading || props.loaderMap) ? null : (props.dataExceptions?.data?.reduce((acc, obj) => acc + obj.count, 0) || 0)
    };

    const totalStats = (statCounts.up === null || statCounts.unk === null || statCounts.down === null || statCounts.odd === null || statCounts.exc === null) 
        ? null 
        : (statCounts.up + statCounts.unk + statCounts.down + statCounts.odd + statCounts.exc);

    return (
        <>
            {filtrosContainer && ReactDOM.createPortal(
                <div style={{marginTop: '7px'}}>
                    <div className="f-lbl">Municipio</div>
                    <Selector opGeneral={true} txtOpGen={capitalizeFirstLetter(lang[props.languaje]['todos'])} opt_de={'0'} origen={'mapa'} data={dataLocations.data.data} loading={dataLocations.loading} titulo={capitalizeFirstLetter(lang[props.languaje]['municipio'])} props={props}></Selector>
                    
                    <div className="f-lbl" style={{marginTop:'7px'}}>Tecnología</div>
                    {(!props.dataTec.loading) ?
                        <Selector userPermissions={props.userPermissions} opGeneral={(props.ubicacion.groupid==390)?true:false} txtOpGen={capitalizeFirstLetter(lang[props.languaje]['todos'])} opt_de={''+dispId_default} origen={'mapa'} data={(props.ubicacion.groupid==390)?[]:dataAuxTecFiltrado} loading={props.dataTec.loading} titulo={capitalizeFirstLetter(lang[props.languaje]['tecnologia'])} props={props}></Selector>
                        : <p className='loadSelect' style={{fontSize: '10px'}}>{capitalizeFirstLetter(lang[props.languaje]['cargando'])}...</p>
                    }
                    
                    <div style={{marginTop:'10px'}}>
                        <Action disabled={props.loaderMap} origen='Azul' titulo={capitalizeFirstLetter(lang[props.languaje]['buscar'])} action={buscar}/>
                    </div>
                </div>,
                filtrosContainer
            )}

            <StatBarNew 
                total={totalStats}
                up={statCounts.up}
                unk={statCounts.unk}
                down={statCounts.down}
                odd={statCounts.odd}
                exc={statCounts.exc}
                onStatClick={handleClickInfo}
                loading={props.loaderMap || props.downs_list.loading}
            />

            <div className="panel-leyenda">
                <div className="leg-lbl">Leyenda</div>
                <div className="leg-row"><span className="dot" style={{background: 'var(--gr)'}}></span> Conectado</div>
                <div className="leg-row"><span className="dot" style={{background: 'var(--red)'}}></span> Desconectado</div>
                <div className="leg-row"><span className="dot" style={{background: 'var(--bg2)', border: '1px solid var(--b2)'}}></span> Desconocido</div>
                <div className="leg-row"><span className="dot" style={{background: 'var(--amb)'}}></span> Excepción</div>
                <div className="leg-row"><span className="dot" style={{background: 'var(--pur)'}}></span> ODD</div>
            </div>

            <Modal
                isOpen={CreateCisModalOpen}
                onRequestClose={closCreateCisModal}
                style={CreateCisModalStyles}
                contentLabel="Example Modal2"
            >
                <InfoContadores tipo={tipo} />
            </Modal>
        </>
    );
}

export default RightQuadrant